// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Jotai from "jotai";
import * as Belt_Option from "@rescript/runtime/lib/es6/Belt_Option.js";
import * as Primitive_option from "@rescript/runtime/lib/es6/Primitive_option.js";
import * as JsxRuntime from "react/jsx-runtime";
import * as RenderIf$OrcaPaymentPage from "./RenderIf.bs.js";
import * as JotaiAtoms$OrcaPaymentPage from "../Utilities/JotaiAtoms.bs.js";

function ErrorComponent(props) {
  let __cvcError = props.cvcError;
  let __expiryError = props.expiryError;
  let __cardError = props.cardError;
  let __errorStr = props.errorStr;
  let __errorStr_value = __errorStr !== undefined ? Primitive_option.valFromOption(__errorStr) : undefined;
  let __cardError_value = __cardError !== undefined ? __cardError : "";
  let __expiryError_value = __expiryError !== undefined ? __expiryError : "";
  let __cvcError_value = __cvcError !== undefined ? __cvcError : "";
  let match = Jotai.useAtomValue(JotaiAtoms$OrcaPaymentPage.configAtom);
  let themeObj = match.themeObj;
  let match$1 = match.config.appearance;
  let innerLayout = match$1.innerLayout;
  let errorTextStyle_alignSelf = "start";
  let errorTextStyle_color = themeObj.colorDangerText;
  let errorTextStyle_fontSize = themeObj.fontSizeSm;
  let errorTextStyle_textAlign = "left";
  let errorTextStyle = {
    alignSelf: errorTextStyle_alignSelf,
    color: errorTextStyle_color,
    fontSize: errorTextStyle_fontSize,
    textAlign: errorTextStyle_textAlign
  };
  let isSpacedErrorShown = __errorStr_value !== undefined ? __errorStr_value.length > 0 : false;
  let isCompressedErrorShown = innerLayout === "Compressed" && (__cardError_value !== "" || __expiryError_value !== "" || __cvcError_value !== "");
  if (innerLayout === "Spaced") {
    return JsxRuntime.jsx(RenderIf$OrcaPaymentPage.make, {
      condition: isSpacedErrorShown,
      children: JsxRuntime.jsx("div", {
        children: Belt_Option.getWithDefault(__errorStr_value, ""),
        className: "Error pt-1",
        style: errorTextStyle
      })
    });
  } else {
    return JsxRuntime.jsx(RenderIf$OrcaPaymentPage.make, {
      condition: isCompressedErrorShown,
      children: JsxRuntime.jsx("div", {
        children: "Invalid input",
        className: "Error pt-1",
        style: errorTextStyle
      })
    });
  }
}

let make = ErrorComponent;

export {
  make,
}
/* jotai Not a pure module */
